import { Text } from 'grommet';

export const TextEmphasis = ({ ...rest }) => {
  return <Text weight={500} color="text-strong" {...rest} />;
};
